import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable, computed } from 'mobx'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { userApi, fileApi } from '@atheneum/api'

import Avatar from './Avatar'
import Edit from '@components/Icon/Edit'
import Spinner from '@components/spinner'

class EditAvatar extends Component {
  static propTypes = {
    uploadStore: PropTypes.object,
    user: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      picturePath: computed(() => get(props.user.picture, 'path'))
    })
  }

  onChange = e => {
    if (e.target.files.length < 1) return null
    const { user, uploadStore } = this.props
    const oldPicture = user.picture

    uploadStore.upload({
      file: e.target.files[0],
      url: 'api/file?public=true',
      onOk: async ({ data }) => {
        const [picture] = data
        return userApi.updatePicture(user.id, picture.id)
          .then(() => {
            user.picture = picture
            oldPicture && fileApi.deletePicture(oldPicture.id)
          })
          .catch(err => {
            user.picture = oldPicture
            throw err
          })
      }
    })
  }

  render () {
    const { user } = this.props
    return (
      <div
        className='link avatar-edit-container'
        onClick={() => this.refs.attachment.click()}
      >
        <input
          className='display-none'
          ref='attachment'
          type='file'
          onChange={this.onChange}
        />
        {this.props.uploadStore.loading ? (
          <Spinner inline />
        ) : (
          <Fragment>
            <Avatar src={get(user.picture, 'path')} />
            <Edit className='edit__profile-pic' />
          </Fragment>
        )}
      </div>
    )
  }
}

export default inject('uploadStore')(observer(EditAvatar))
